const navColorConfig = {
  whiteLogo: [
    '/',
    '/australia',
    '/phillippines',
    '/login',
    '/forgot-password',
    '/programs/program-detail',
    '/couriers/courier-detail',
    '/couriers/about',
    '/clean-water-corps',
    '/clean-water-corps/cwc-detail',
    '/about',
    '/solutions',
    '/partners/case-study',
    '/password-reset',
  ],
  whiteNavItems: [
    '/',
    '/australia',
    '/phillippines',
    '/programs/program-detail',
    '/couriers/courier-detail',
    '/couriers/about',
    '/clean-water-corps',
    '/clean-water-corps/cwc-detail',
    '/about',
    '/partners/case-study',
    '/solutions',
  ],
  blackMobileBackground: [
    '/',
    '/solutions',
    '/clean-water-corps',
    '/programs/program-detail',
    '/couriers/about',
    '/partners/case-study',
  ],
  whiteMobileItems: [
    '/',
    '/solutions',
    '/clean-water-corps',
    '/about',
    '/couriers/courier-detail',
    '/programs/program-detail',
    '/couriers/about',
    '/partners/case-study',
  ],
};

export default navColorConfig;
